import { setupInfrastructureBindings } from './bindings/infrastructure'
import { setupRepositoryBindings } from './bindings/repositories'
import { setupApplicationBindings } from './bindings/application'

export const setupContainer = () => {
  // Setup bindings in order of dependencies
  setupInfrastructureBindings()
  setupRepositoryBindings()
  setupApplicationBindings()
}

export * from './container'
export * from './types'